import { z } from "zod";

export const deliveryMethod = z.enum(["automatic", "manual", "unknown"]);
export type DeliveryMethod = z.infer<typeof deliveryMethod>;
